import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { decimalEliminate, decimalThree, decimalTwo } from "../../Utils/commonUtil";
import Nominee_Cards_List from './Nominee_Cards_List';


const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Dist_RO_data = async (params) => {  
        const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/Nominee_FPS_Abstract`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Nominee_Dist_Abstract = ({ month,year,dist_code,dist_name,afso_code,afso_name_en,  heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading); 
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsLoad = useRef(null);  
    const handleDistClick = (dist_code,dist_name,afso_code,afso_name_en,fps_id) => {
        setRenderContentt(null);
        console.log(fps_id);

        setTimeout(() => {
            setRenderContentt(
                <Nominee_Cards_List  dist_code={dist_code} dist_name={dist_name}  afso_code={afso_code} afso_name_en={afso_name_en} fps_id ={fps_id} heading={tabHeading} />
            );
        }, 10);
        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Dist_RO_data({month,year,dist_code,afso_code});
               
                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month,year,dist_code,afso_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoad.current) {
            // detailsLoad.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsLoad.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
         }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
    const totals = reportData.reduce(
        (acc, item) => {
          acc.total+=  parseFloat(item.total) || 0;
          acc.drawn += parseFloat(item.drawn) || 0;
          acc.nominee += parseFloat(item.nominee) || 0;
          acc.self += parseFloat(item.self) || 0;
          return acc;
        },
        {
            total: 0,
            drawn: 0,
            nominee: 0,
            self: 0,
          }
      );
    return (
        <>

            <table align="center" width="50%" border={1}  ref={detailsLoad}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}>
                        {heading} on 
                        <font  style={{color: 'orange'}} >  {MonthC[month-1]}'{year} - {dist_name}/{afso_name_en}</font> 
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>FPS Id</th>
                        <th colSpan={4}>Cards</th>

                     </tr>
                     <tr className="tableheader">
                        <th  >Nominee<br/>Mapped</th>
                        <th  >Total<br/>Drawn</th>
                        <th  >Nominee<br/>Drawn</th>
                        <th  >Self<br/>Drawn</th>
                         </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.fps_id}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                            {item.fps_id}
                                 </td>
                                <td style={{ textAlign: 'right' }}>
                                <a style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick(item.dist_code,item.dist_name_en,afso_code,afso_name_en,item.fps_id)} >
                               {item.total}
                               </a>
                               </td>
                            <td style={{ textAlign: 'right' }}>{item.drawn}</td>
                            <td style={{ textAlign: 'right' }}>{item.nominee}</td>
                            {/* <td style={{ textAlign: 'right' }}>{(item.drawn - item.nominee)||0}</td> */}
                            <td style={{ textAlign: 'right' }}>{item.self}</td>

                        </tr>
                    ))}
                </tbody>
                <tr className="tableheader">
                <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.drawn}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.nominee}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.self}</td>
 
            </tr>
            </table>
            <br /><br />
            <div id="detailsERR">{renderContentt}<br /><br /></div>
        
        </>
    );
};

export default Nominee_Dist_Abstract;
